export default {
    manage_createEditWorkOrderType_editTitle: "Editar Tipo de Orden de Trabajo",
    manage_createEditWorkOrderType_createTitle: "Crear Nuevo Tipo de Orden de Trabajo",
    manage_createEditWorkOrderType_createSuccess: "Tipo de orden de trabajo guardada",
    manage_createEditWorkOrderType_name: "Nombre",
    manage_createEditWorkOrderType_assingForm: "Formulario",
    manage_createEditWorkOrderType_description: "Descripción",
    manage_createEditWorkOrderType_estimatedDurationMins: "Duración Estimada (minutos)",
    manage_createEditWorkOrderType_duplicatedName: "El nombre ya está en uso",
}